import React, { useState } from 'react';
import { Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Grid from '@material-ui/core/Grid';
import TableBody from '@material-ui/core/TableBody';

import PropTypes from 'prop-types';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import { makeSelectClients } from '../../selectors/clients';
import {
  SetSubscriptionClient,
  addClientSubscription,
  removeClientSubscription,
  setClient,
} from '../../actions/clients';
import SubscriptionRow from './SubscriptionRow';

const useStyles = makeStyles(theme => ({
  clickable: {
    cursor: 'pointer',
  },
  wrapper: {
    paddingTop: theme.spacing(3),
  },
  grid: {
    paddingTop: theme.spacing(2.5),
    paddingBottom: theme.spacing(2.5),
  },
  sectionTitle: {
    borderBottom: '2px solid #DFDFDF',
    padding: theme.spacing(3),
  },
  button: {
    margin: theme.spacing(2.5),
  },
}));

const headCells = [
  { id: 'name', numeric: false, disablePadding: true, label: 'Name' },
  { id: 'description', numeric: false, disablePadding: true, label: 'Description' },
  { id: 'subscribed', numeric: false, disablePadding: true, label: 'Subscribed' },
  { id: 'tier', numeric: false, disablePadding: true, label: 'Tier' },
];

function ClientSubscriptionTable(props) {
  const { selectedClient, onSetSubscription, onSubscribe, onUnsubscribe, onSetClient } = props;
  const [selectedSubscription, setSelectedSubscription] = useState(null);

  let thisSubscriptions = [];
  // let thisClient = {};
  if ('subscriptions' in selectedClient) {
    thisSubscriptions = selectedClient.subscriptions;
  }

  const tblArr = [
    ...thisSubscriptions.map(sub => ({
      id: sub.auth0ClientId,
      name: sub.name,
      description: sub.description,
      subscribed: sub.isSubscribed,
      tier: sub.subscriptionTier,
    })),
  ];

  const classes = useStyles();
  return (
    <Grid className={classes.grid} maxwidth="lg">
      <Paper>
        <Grid container spacing={0} direction="row" wrap="nowrap">
          <Grid item xs={8}>
            <Typography className={classes.sectionTitle} variant="h5" component="h3">
              Subscriptions
            </Typography>
          </Grid>
        </Grid>
        <Container className={classes.wrapper} maxwidth="lg">
          <Table>
            <TableHead>
              <TableRow>
                {headCells.map(headCell => (
                  <TableCell
                    key={headCell.id}
                    align={headCell.numeric ? 'right' : 'left'}
                    padding={headCell.disablePadding ? 'none' : 'default'}
                  >
                    <Typography variant="h6">{headCell.label}</Typography>
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {tblArr.map(row => (
                <SubscriptionRow
                  row={row}
                  selectedSubscription={selectedSubscription}
                  onSetSubscription={onSetSubscription}
                  setSelectedSubscription={setSelectedSubscription}
                  selectedClient={selectedClient}
                  onSetClient={onSetClient}
                  onSubscribe={onSubscribe}
                  onUnsubscribe={onUnsubscribe}
                />
              ))}
            </TableBody>
          </Table>
        </Container>
      </Paper>
    </Grid>
  );
}

ClientSubscriptionTable.defaultProps = {
  selectedClient: {},
};

ClientSubscriptionTable.propTypes = {
  selectedClient: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    billingAddressLine1: PropTypes.string,
    billingAddressLine2: PropTypes.string,
    billingAddressZip: PropTypes.string,
    billingAddressState: PropTypes.string,
    billingAddressCity: PropTypes.string,
    subscriptions: PropTypes.arrayOf(
      PropTypes.shape({
        applicationId: PropTypes.number,
        clientId: PropTypes.number,
        deletedAt: PropTypes.string,
        auth0ClientId: PropTypes.string,
        name: PropTypes.string,
        isSubscribed: PropTypes.bool,
      })
    ),
  }),
};

ClientSubscriptionTable.propTypes = {
  onSetClient: PropTypes.func.isRequired,
  onSetSubscription: PropTypes.func.isRequired,
  onSubscribe: PropTypes.func.isRequired,
  onUnsubscribe: PropTypes.func.isRequired,
};

const mapStateToProps = createStructuredSelector({
  clients: makeSelectClients(),
});

export function mapDispatchToProps(dispatch) {
  return {
    onSetClient: clientId => dispatch(setClient(clientId)),
    onSetSubscription: subId => dispatch(SetSubscriptionClient(subId)),
    onSubscribe: tier => dispatch(addClientSubscription(tier)),
    onUnsubscribe: () => dispatch(removeClientSubscription()),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ClientSubscriptionTable);
